<template>
  <LoadingWrapper :state="organizationFeedbackTopicsStatus">
    <ManageFeedbackTopics
      :feedback-topics="feedbackTopics"
      @feedback-topic-enabled-updated="onFeedbackTopicEnabledUpdated"
    />
  </LoadingWrapper>
</template>
<script lang="ts" setup>
  import { onMounted } from 'vue'
  import { useRouter } from 'vue-router'
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import { useApplicationModule } from '@/core/composables/use-application-module'
  import { ApplicationModule } from '@/core/models/organization'
  import ManageFeedbackTopics from '../components/ManageFeedbackTopics.vue'
  import { useOrganizationFeedbackTopics } from '../composables/use-organization-feedback-topics'

  const router = useRouter()
  const { hasModule } = useApplicationModule()

  onMounted(() => {
    if (hasModule(ApplicationModule.LUMIA)) {
      router.replace({ name: 'settings-organization-general' })
    }
  })

  const {
    status: organizationFeedbackTopicsStatus,
    feedbackTopics,
    setFeedbackTopicEnabled,
  } = useOrganizationFeedbackTopics()

  const onFeedbackTopicEnabledUpdated = async (input: {
    feedbackTopicId: string
    enabled: boolean
  }) => {
    await setFeedbackTopicEnabled(input.feedbackTopicId, input.enabled)
  }
</script>
